module.exports = __webpack_public_path__ + "709b50e07fcfc571653d15d45d9a90de.png";